import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";
export function cardNum(num, className, classlength) {
  var numArr = num.toString().split('');
  var card = document.getElementsByClassName(className);

  for (var i = 0; i <= classlength; i++) {
    var cur = numArr[numArr.length - (i + 1)] || 0;
    card[classlength - i].style.backgroundPosition = '0px ' + -41 * cur + 'px';
  }
}
export function getBeforeDate() {
  var base = new Date().getTime();
  var oneDay = 24 * 3600 * 1000;
  var date = [];
  var data = [Math.random() * 300];
  var time = new Date(base);

  for (var i = 0; i < 7; i++) {
    var now = new Date(base -= oneDay);
    var month = now.getMonth();
    month = month < 9 ? '0' + (month + 1) : month + 1;
    var day = now.getDate();
    day = day < 10 ? '0' + day : day;
    date.push([now.getFullYear(), month, day].join(''));
    data.push(Math.round((Math.random() - 0.5) * 20 + data[i - 1]));
  }

  var newdate = date.reverse();
  console.log(newdate);
  return newdate;
}
export function secondToHour(second) {
  var hour = Math.floor(second / 3600);
  var residurmin = second - hour * 3600;
  var min = Math.floor(residurmin / 60);
  var sec = residurmin % 60;
  return hour + '时' + min + '分' + sec + '秒';
}